import { globalTheme } from "../../Theme/Theme";
import { customProps } from "../../Theme/GlobalStyles";

import styled from "styled-components";

export const ToolWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
      position: relative;
      display: inline-flex;
      cursor: pointer;

        .toolTip{
          position: absolute;
          min-width: ${({ minWidth }) => minWidth || '230px'};
          max-width: ${({ maxWidth }) => maxWidth || '230px'};
          font-size: 12px;
          overflow-wrap: break-word;
          white-space: normal;
          font-weight: 500;
          transform: translateY(-50%);
          background-color: ${globalTheme.colors.grey1};
          color: ${globalTheme.colors.white1};
          padding: 8px 12px;
          border-radius: 8px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
          /* Sticky table heads sit at 99, so a tooltip inside a table row was
             being painted under the header when it opened upward. */
          z-index: ${({ $zIndex }) => $zIndex || '150'};

            &.toolTip-Right{
              top: 50%;
            left: ${({ right }) => right || '100%'};
              right: -38%;
              width: max-content;

              .ToolArrow{
                    position: absolute;
                    top: 50%;
                   ${props => props.right ? 'left: -14px;' : 'left: -7px;'}
                    transform: translateY(-50%);
              }
          }
          &.toolTip-Top{
                bottom: 100%;
                transform: translateX(-50%);
                right: 50%;
                left: 50%;

              .ToolArrow{
                    position: absolute;
                    bottom: -7px;
                    left: 50%;
                    transform: translateX(-50%);
              }
          }
          &.toolTip-Bottom{
                top: 100%;
                left: 50%;
                right: 50%;
                transform: translateX(-50%);

              .ToolArrow{
                    position: absolute;
                    Top: -7px;
                    left: 50%;
                    transform: translateX(-50%);
              }
          }
        }
`